import React from 'react';
import Layout from '../../components/index-layout'
import Navigation from '../../components/navigation'
import {Link} from 'react-router-dom'
import './index.css'
import banner01 from './../../pic/banner01.jpg'
import banner02 from './../../pic/banner02.jpg'
import banner03 from './../../pic/banner03.jpg'
import banner04 from './../../pic/banner04.jpg'
import lehuilin from './../../pic/lehuilin.jpg'
import linsheng from './../../pic/linsheng.jpg'
import sunyiwen from './../../pic/sunyiwen.jpg'
import xuanqi from './../../pic/xuanqi.jpg'
import zhuyeming from './../../pic/zhuyeming.jpg'
import xuyingming from './../../pic/xuyingming.jpg'
import sunwei from './../../pic/sunwei.jpg'
import shijialuo from './../../pic/shijialuo.jpg'

import playOS from './../../images/play_circle_orange_s.png'
import playWS from './../../images/play_circle_white_s.png'
import arrowBL from './../../images/arrow_bgblack_left.png'
import arrowBR from './../../images/arrow_bgblack_right.png'
import arrowL from './../../images/arrow_left.png'
import arrowR from './../../images/arrow_right.png'
import hot from './../../images/hot.png'
import arrow from './../../images/arrow_more_left.png'
import arrowRB from './../../images/arrow_right_blackbg.png'
import arrowLB from './../../images/arrow_left_blackbg.png'
var isMobile = false;
const width = document.body.clientWidth;
if(width < 600){
    isMobile = true;
}

export default class index extends React.Component {
    state = {
        bannerBgList:[],
        bannerTitleList:[],
        bannerUrlList:[],
        bannerClickIndex: 0,//0 4张靠左 1 4张靠右
        bannerHoverIndex: 1,
        equipmentIndex:0,
        starList:[],
        starNameList:[],
        starPage:1,
        peoplePage:1,
        videoIndex:0,
        videoCamList:[],
        videoCamIndex:1,
        videoHeroList:[],
        videoHeroIndex:1,
        isMobile
    }
        
    componentWillMount(){
        console.log(this.state.isMobile)
        var arr = [banner01,banner02,banner03]
        this.setState({bannerBgList:arr});
        var arr1 = ['绍兴柯桥 首届击剑冠军赛火热开赛','第二届中国击剑大师赛在昌落幕','武汉军运会击剑测试赛开赛']
        this.setState({bannerTitleList:arr1});
        var arr2 = ['f0032t8ftgp','b3006nt3239','t089999q0qi']
        this.setState({bannerUrlList:arr2});
        var star = [lehuilin,linsheng,sunyiwen,xuanqi,zhuyeming,xuyingming,sunwei,shijialuo]
        this.setState({starList:star});
        var star1 = ['乐慧林','林声','孙一文','许安琪','朱明叶','许英明','孙伟','施嘉洛'];
        this.setState({starNameList:star1});
        var videoCamList = ['a01786ijqla','a0930ar1pv3','t09287v6zmt','j30065rrb9d','k09022di15l','j0914to7cbv','f0929g3wzib'];
        this.setState({videoCamList:videoCamList});
        var videoHeroList = ['u0029cj6joi','hero03.mp4','p0818mq4x5k','m0365vyb5vh','s300570td9z','hero06.mp4'];
        this.setState({videoHeroList:videoHeroList});
        
    }
    changeClickIndex=(index)=>{
        var arr=[];
        index === 0 ? arr = [banner01,banner02,banner03] : arr = [banner02,banner03,banner04]
        this.setState({bannerBgList:arr});
        var arr1=[];
        index === 0 ? arr1 = ['绍兴柯桥 首届击剑冠军赛火热开赛','第二届中国击剑大师赛在昌落幕','武汉军运会击剑测试赛开赛'] : arr1 = ['第二届中国击剑大师赛在昌落幕','武汉军运会击剑测试赛开赛','全国击剑冠军赛 千余名剑客上虞“论剑”']
        this.setState({bannerTitleList:arr1});
        var arr2=[];
        index === 0 ? arr2 = ['f0032t8ftgp','b3006nt3239','t089999q0qi'] : arr2= ['b3006nt3239','t089999q0qi','a0863uizi9r']
        this.setState({bannerUrlList:arr2});
        this.setState({bannerClickIndex:index})
        this.setState({bannerHoverIndex:index+1})
    }
    toggleHover=(index)=>{
        this.setState({bannerHoverIndex:index})
    }
    starPageAdd=()=>{
        if(this.state.starPage === 3) return;
        var page = this.state.starPage;
        this.setState({starPage:++page})
    }
    starPageRemove=()=>{
        if(this.state.starPage === 1) return;
        var page = this.state.starPage;
        this.setState({starPage:--page})
    }
    peoplePageAdd=()=>{
        if(this.state.peoplePage === 2) return;
        var page = this.state.peoplePage;
        this.setState({peoplePage:++page})
    }
    peoplePageRemove=()=>{
        if(this.state.peoplePage === 1) return;
        var page = this.state.peoplePage;
        this.setState({peoplePage:--page})
    }
    changeVideoIndex=(index)=>{
        this.setState({videoIndex:index})
    }
    toggleVideoDes=()=>{
        var cover = document.querySelector(".list .cover")
        cover.classList.toggle("cover_close")
    }
    toggleEquipmentHover=(index)=>{
        this.setState({equipmentIndex:index})
    }
    goVideo=()=>{

    }
    changeCamVideo=(index)=>{
        this.setState({videoCamIndex:index})
    }
    changeHeroVideo=(index)=>{
        this.setState({videoHeroIndex:index})
    }
    render(){
        return (
            <main>
                
            {!this.state.isMobile ? (
                <section>
                    <Navigation tab="index"></Navigation>
                    <div className="banner_container">
                        <div className="banner">
                            {this.state.bannerClickIndex === 1 ? (  
                                <div>
                                    <div className="arrow arrowr">
                                        <img src={arrowL} alt=""></img>
                                    </div>
                                    <div className="arrow arrowl" onClick={this.changeClickIndex.bind(this, 0)}>
                                        <img src={arrowBR} alt=""></img>
                                    </div>
                                </div>
                            ):(  
                                <div> 
                                    <div className="arrow arrowr" onClick={this.changeClickIndex.bind(this, 1)}>
                                        <img src={arrowBL} alt=""></img>
                                    </div>
                                    <div className="arrow arrowl">
                                        <img src={arrowR} alt=""></img>
                                    </div>
                                </div>
                            )}
                            <div className="pic">
                                {this.state.bannerBgList.map((bg,index) =>
                                <Link to={"/video/"+this.state.bannerUrlList[index]+'/1'} key={index} >
                                    <div style={{transform: (this.state.bannerHoverIndex === index ? "scale(1.14)" : '')}} 
                                        onMouseEnter={this.toggleHover.bind(this,index)} 
                                        onMouseLeave={this.toggleHover.bind(this,index)}
                                        onClick={this.goVideo.bind(this,index)}>  
                                            <img src={bg} alt={index}></img>
                                            {this.state.bannerHoverIndex === index ? (
                                                <div className="default hover">
                                                    <p>{this.state.bannerTitleList[index]}</p>
                                                    <div className="play">
                                                        <img src={playWS} alt=""></img>
                                                        <span>立即播放</span>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="default">
                                                    <p>{this.state.bannerTitleList[index]}</p>
                                                    <div className="play">
                                                        <img src={playOS} alt=""></img>
                                                        <span>播放量：{(index+1)*120+index*3+9+index}</span>
                                                    </div>
                                                </div>
                                            )}
                                    </div>
                                </Link>
                                )}
                            </div>
                            <div className="hot">
                                <p className="title">
                                    <img src={hot} alt=""></img>
                                    <span>今日头条</span>
                                </p>
                                <Link to="/info/1"><p className="detail">苏州市击剑联赛暨长三角击剑公开赛总决赛延期通知</p></Link>
                                <Link to="/info/2"><p className="detail">搭乘5G/VR黑科技，2019-2020赛季全国击剑冠军赛第一站28日在扬开赛</p></Link>
                                <Link to="/info/3"><p className="detail">2019年成都市首届中小学生比赛暨金牛区中小学生击剑锦标赛开赛</p></Link>
                                <Link to="/info/5"><p className="detail">2019年市青少年击剑锦标赛落幕：多点合力共促发展</p></Link>
                            </div>
                        </div>
                    </div>
                    <div className="recent_games">
                        <Layout title="热门赛事" moreTitle="更多赛事" more="true" moreUrl="/match">
                            <div className="line"></div>
                            <div className="games">
                                <div style={{color:'#333'}} className="hover">
                                    <div className="spot"></div>
                                    <p className="title">锦标赛预赛</p>
                                    <p className="time">05月30日</p>
                                    <div className="content">
                                        <p>全国青年击剑锦标赛暨二青会预赛第二站</p>
                                        <p style={{color:'#FF5D38'}}>05.30-06.05</p>
                                        <p>长沙</p>
                                    </div>
                                </div>
                                <div style={{color:'#333'}} className="hover">
                                    <div className="spot"></div>
                                    <p className="title">锦标赛</p>
                                    <p className="time">10月28日</p>
                                    <div className="content">
                                        <p>全国击剑锦标赛</p>
                                        <p style={{color:'#FF5D38'}}>10.28</p>
                                        <p>西安</p>
                                    </div>
                                </div>
                                <div style={{color:'#333'}} className="hover">
                                    <div className="spot"></div>
                                    <p className="title">锦标赛</p>
                                    <p className="time">11月20日</p>
                                    <div className="content">
                                        <p>第25届中国大学生击剑锦标赛</p>
                                        <p style={{color:'#FF5D38'}}>11.20-11.26</p>
                                        <p>厦门</p>
                                    </div>
                                </div>
                                <div style={{color:'#333'}} className="hover">
                                    <div className="spot"></div>
                                    <p className="title">俱乐部联赛</p>
                                    <p className="time">11月23日</p>
                                    <div className="content">
                                        <p>陕西省青少年击剑俱乐部联赛</p>
                                        <p style={{color:'#FF5D38'}}>11.23</p>
                                        <p>陕西</p>
                                    </div>
                                </div>
                            </div>
                        </Layout>
                    </div>
                    <div className="heavy_pound_and_interview">
                        <div className="heavy_pound">
                            <Layout title="重磅">
                                <ul>
                                    <Link to="/info/10">
                                    <li>
                                        <img src={require('./../../pic/heavy_pound01.jpg')} alt=""></img>
                                        <div className="content">
                                            <p>击剑——世锦赛：中国队夺得女子重剑团体冠军</p>
                                            <p>中国女子重剑队队员、教练员、中国击剑协会主席王海滨（前排右四）等在颁奖仪式上合影。</p>
                                            <p></p>
                                        </div>
                                    </li>
                                    </Link>
                                    <Link to="/info/11">
                                    <li>
                                        <img src={require('./../../pic/heavy_pound11.jpg')} alt=""></img>
                                        <div className="content">
                                            <p>中国选手钱佳睿获得第七届世界军人运动会女子佩剑亚军</p>
                                            <p>在武汉举行的第七届世界军人运动会女子佩剑个人赛决赛中，中国选手钱佳睿以11比15不敌俄罗斯选手埃戈里安，获得亚军。</p>
                                            <p></p>
                                        </div>
                                    </li>
                                    </Link>
                                    <Link to="/info/12">
                                    <li>
                                        <img src={require('./../../pic/heavy_pound21.jpg')} alt=""></img>
                                        <div className="content">
                                            <p>2019中国击剑俱乐部联赛总决赛（渭南站）明日在渭南经开区举办</p>
                                            <p>11月27日，渭南经开区召开2019中国击剑俱乐部联赛总决赛（渭南站）协调会议。会上获悉，2019中国击剑俱乐部联赛总决赛（渭南站）将于11月29日至12月1日在渭南经开区申华汽博园举办。</p>
                                            <p></p>
                                        </div>
                                    </li>
                                    </Link>
                                </ul>
                            </Layout>
                        </div>
                        <div className="interview">
                            <div className="layout">
                                <div>
                                    <span>精彩专访</span>
                                    <div>
                                        {this.state.peoplePage < 2 &&
                                            <img src={arrow} alt="" onClick={this.peoplePageAdd.bind(this)} className="add"></img>   
                                        } 
                                    </div>
                                    <span style={{float:'right',marginTop:'.16rem'}}>{this.state.peoplePage}/<b style={{fontWeight:400,color:this.state.peoplePage < 2 ? '#999999' : '#333333'}}>2</b></span>
                                    <div>
                                        {this.state.peoplePage > 1 &&
                                            <img src={arrow} alt="" onClick={this.peoplePageRemove.bind(this)} className="remove"></img> 
                                        } 
                                    </div>  
                                </div>
                            </div>
                            {this.state.peoplePage === 1 &&
                                <div className="people">
                                    <Link to="/interview/4">
                                        <div style={{backgroundImage:"url("+require('./../../pic/interview32_s.jpg')+")"}}>
                                            <div className="name">
                                                <b>孙伟</b> 中国击剑队男子佩剑运动员
                                            </div>
                                            <div className="introduce">
                                                <p>孙伟<b>中国击剑队男子佩剑运动员</b></p>
                                                <p>专访孙伟：希望大家认识击剑魅力 拥有健康体魄</p>
                                                <p>2002年，孙伟进入徐州市少年儿童体校击剑队训练。2005年，孙伟进入江苏省击剑队。2008年入选国家击剑队。2009年，孙伟获得全国击剑锦标赛男子佩剑个人亚军。</p>
                                                <p>查看详情</p>
                                            </div>
                                        </div>
                                    </Link>
                                    <Link to="/interview/2">
                                        <div style={{backgroundImage:"url("+require('./../../pic/interview11_s.jpg')+")"}}>
                                            <div className="name">
                                                <b>谭雪</b> 女子击剑运动员
                                            </div>
                                            <div className="introduce">
                                                <p>谭雪<b>女子击剑运动员</b></p>
                                                <p>击剑世界冠军谭雪：离开赛场，依然执剑前行！</p>
                                                <p>1998年，谭雪进入天津市体校体工大队分校，并在天津击剑队改练击剑 。2001年，进入国家击剑队，教练茅祎勋 。2002年，在里斯本进行的世界锦标赛女子佩剑比赛中，谭雪获得金牌。</p>
                                                <p>查看详情</p>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            } 
                            {this.state.peoplePage === 2 &&
                                <div className="people"> 
                                    <Link to="/interview/3">
                                        <div style={{backgroundImage:"url("+require('./../../pic/interview01_s.jpg')+")"}}>
                                            <div className="name">
                                                <b>林声</b> 中国击剑运动员
                                            </div>
                                            <div className="introduce">
                                                <p>林声<b>中国击剑运动员</b></p>
                                                <p>专访林声：银牌是新的开始 原本个人赛只想找感觉</p>
                                                <p>2018年3月，在2018年国际剑联重剑世界杯大奖赛（西班牙站）摘得个人赛银牌。 2018年7月25日，2018年世界击剑锦标赛，由许诚子、朱明叶、林声和孙一文组成的团体获得铜牌。</p>
                                                <p>查看详情</p>
                                            </div>
                                        </div>
                                    </Link>
                                    <Link to="/interview/1">
                                        <div style={{backgroundImage:"url("+require('./../../pic/interview23_s.jpg')+")"}}>
                                            <div className="name">
                                                <b>刘倩</b> 国家击剑队健将级运动员
                                            </div>
                                            <div className="introduce">
                                                <p>刘倩<b>国家击剑队健将级运动员</b></p>
                                                <p>专访原国家队健将级运动员：击剑有助塑造孩子的身形和品格？</p>
                                                <p>刘倩初二开始学击剑，练了14年。她与击剑结缘，是奥运会做了她的启蒙。</p>
                                                <p>查看详情</p>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            } 
                        </div> 
                    </div>                       
                    <div className="star">
                        <div className="layout">
                            <div>
                                <span>击剑明星</span>
                                {/* <div>
                                    {this.state.starPage < 3 &&
                                        <img src={arrow} alt="" onClick={this.starPageAdd.bind(this)} className="add"></img>   
                                    } 
                                </div>
                                <span>{this.state.starPage}/<b style={{fontWeight:400,color:this.state.starPage < 3 ? '#999999' : '#333333'}}>3</b></span>
                                <div>
                                    {this.state.starPage > 1 &&
                                        <img src={arrow} alt="" onClick={this.starPageRemove.bind(this)} className="remove"></img> 
                                    } 
                                </div>   */}
                            </div>
                        </div>   
                        <ul className="list" style={{marginLeft:-(this.state.starPage-1)*12.32+'rem'}}>
                            {this.state.starList.map((star,index) =>
                                <Link to={'/match/'+index}>
                                <li key={index}>
                                    <img src={star} alt=""/>
                                    <p>{this.state.starNameList[index]}</p>
                                </li>
                                </Link>
                            )}
                        </ul>
                    </div>                 
                    <div className="video_list">
                        <div className="tab">
                            <span onClick={this.changeVideoIndex.bind(this,0)} className={this.state.videoIndex === 0 ? 'active' : ''}>冠军赛</span>
                            <span onClick={this.changeVideoIndex.bind(this,1)} className={this.state.videoIndex === 1 ? 'active' : ''}>英雄传说</span>
                        </div>
                        {this.state.videoIndex === 0 &&
                        <div className="list">
                            <div className="leftInner">
                                <iframe src={"http://v.qq.com/txp/iframe/player.html?vid="+this.state.videoCamList[this.state.videoCamIndex]}></iframe>
                                <div className="play">
                                    <img src={playOS} alt=""></img>
                                    <span>播放量：200</span>
                                </div>
                                <div className="arrow_r" onClick={this.toggleVideoDes}>
                                    <img src={arrowRB} alt=""></img>
                                </div>
                                <div className="cover">
                                    <div className="arrow" onClick={this.toggleVideoDes}>
                                        <img src={arrowLB} alt=""></img>
                                    </div>
                                    <p style={{color:(this.state.videoCamIndex == 1 ? '#ff5d38' : '#fff')}} onClick={this.changeCamVideo.bind(this,1)}>2018-2019赛季全国击</p>
                                    <p style={{color:(this.state.videoCamIndex == 2 ? '#ff5d38' : '#fff')}} onClick={this.changeCamVideo.bind(this,2)}>2018-2019赛季全国击剑</p>
                                    <p style={{color:(this.state.videoCamIndex == 3 ? '#ff5d38' : '#fff')}} onClick={this.changeCamVideo.bind(this,3)}>2019“国庆杯”武汉市击剑</p>
                                    <p style={{color:(this.state.videoCamIndex == 4 ? '#ff5d38' : '#fff')}} onClick={this.changeCamVideo.bind(this,4)}>2019世界击剑锦标赛女重</p>
                                    <p style={{color:(this.state.videoCamIndex == 5 ? '#ff5d38' : '#fff')}} onClick={this.changeCamVideo.bind(this,5)}>二青会击剑比赛</p>
                                    <p style={{color:(this.state.videoCamIndex == 6 ? '#ff5d38' : '#fff')}} onClick={this.changeCamVideo.bind(this,6)}>全国击剑冠军赛总决赛</p>
                                </div>
                            </div>
                            <ul className="rightInner">
                                <Link to={"/video/"+this.state.videoCamList[1]+'/1'}>
                                <li style={{backgroundImage:'url('+require('./../../pic/champion02.jpg')+')'}} title="2018-2019赛季全国击剑冠军赛">
                                    <div className="play">
                                        <img src={playOS} alt=""></img>
                                        <span style={{color:(this.state.videoCamIndex == 1 ? '#ff5d38' : '#fff')}}>2018-2019赛季全国击</span>
                                    </div>
                                </li>
                                </Link>
                                <Link to={"/video/"+this.state.videoCamList[2]+'/1'}>
                                <li style={{backgroundImage:'url('+require('./../../pic/champion03.jpg')+')'}} title="2018-2019赛季全国击剑总决赛（二）">
                                    <div className="play">
                                        <img src={playOS} alt=""></img>
                                        <span style={{color:(this.state.videoCamIndex == 2 ? '#ff5d38' : '#fff')}}>2018-2019赛季全国击</span>
                                    </div>
                                </li>
                                </Link>
                                <Link to={"/video/"+this.state.videoCamList[3]+'/1'}>
                                <li style={{backgroundImage:'url('+require('./../../pic/champion04.jpg')+')'}} title="2019“国庆杯”武汉市击剑冠军赛">
                                    <div className="play">
                                        <img src={playOS} alt=""></img>
                                        <span style={{color:(this.state.videoCamIndex == 3 ? '#ff5d38' : '#fff')}}>2019“国庆杯”武汉市</span>
                                    </div>
                                </li>
                                </Link>
                                <Link to={"/video/"+this.state.videoCamList[4]+'/1'}>
                                <li style={{backgroundImage:'url('+require('./../../pic/champion05.jpg')+')'}} title="2019世界击剑锦标赛女重团体决赛（中国VS俄罗斯）">
                                    <div className="play">
                                        <img src={playOS} alt=""></img>
                                        <span style={{color:(this.state.videoCamIndex == 4 ? '#ff5d38' : '#fff')}}>2019世界击剑锦标赛女</span>
                                    </div>
                                </li>
                                </Link>
                                <Link to={"/video/"+this.state.videoCamList[5]+'/1'}>
                                <li style={{backgroundImage:'url('+require('./../../pic/champion06.jpg')+')'}} title="二青会击剑比赛 西安女子花剑勇夺团体冠军">
                                    <div className="play">
                                        <img src={playOS} alt=""></img>
                                        <span style={{color:(this.state.videoCamIndex == 5 ? '#ff5d38' : '#fff')}}>二青会击剑比赛</span>
                                    </div>
                                </li>
                                </Link>
                                <Link to={"/video/"+this.state.videoCamList[6]+'/1'}>
                                <li style={{backgroundImage:'url('+require('./../../pic/champion07.jpg')+')'}} title="全国击剑冠军赛总决赛第三日集锦">
                                    <div className="play">
                                        <img src={playOS} alt=""></img>
                                        <span style={{color:(this.state.videoCamIndex == 6 ? '#ff5d38' : '#fff')}}>全国击剑冠军赛总决赛</span>
                                    </div>
                                </li>
                                </Link>
                            </ul>
                        </div>
                    }
                    {this.state.videoIndex === 1 &&
                        <div className="list">
                            <div className="leftInner" style={{backgroundImage:'url('+require('./../../pic/hero01.jpg')+')'}}>
                                {(this.state.videoHeroIndex == 1 || this.state.videoHeroIndex == 5) &&
                                    <video src={require('./../../video/'+this.state.videoHeroList[this.state.videoHeroIndex])} controls autoPlay></video>
                                }
                                {this.state.videoHeroIndex != 1 && this.state.videoHeroIndex != 5 &&
                                    <iframe src={"http://v.qq.com/txp/iframe/player.html?vid="+this.state.videoHeroList[this.state.videoHeroIndex]}></iframe>
                                }
                                <div className="play">
                                    <img src={playOS} alt=""></img>
                                    <span>播放量：200</span>
                                </div>
                                <div className="arrow_r" onClick={this.toggleVideoDes}>
                                    <img src={arrowRB} alt=""></img>
                                </div>
                                <div className="cover">
                                    <div className="arrow" onClick={this.toggleVideoDes}>
                                        <img src={arrowLB} alt=""></img>
                                    </div>
                                    <p style={{color:(this.state.videoHeroIndex == 1 ? '#ff5d38' : '#fff')}} onClick={this.changeHeroVideo.bind(this,1)}>广东击剑队队员邓小浩专访</p>
                                    <p style={{color:(this.state.videoHeroIndex == 2 ? '#ff5d38' : '#fff')}} onClick={this.changeHeroVideo.bind(this,2)}>击剑运动员 雷声 演讲</p>
                                    <p style={{color:(this.state.videoHeroIndex == 3 ? '#ff5d38' : '#fff')}} onClick={this.changeHeroVideo.bind(this,3)}>击剑运动员孙伟 访谈</p>
                                    <p style={{color:(this.state.videoHeroIndex == 4 ? '#ff5d38' : '#fff')}} onClick={this.changeHeroVideo.bind(this,4)}>2019世界击剑锦标赛女重团体决赛（中国VS俄罗斯）</p>
                                    <p style={{color:(this.state.videoHeroIndex == 5 ? '#ff5d38' : '#fff')}} onClick={this.changeHeroVideo.bind(this,5)}>中国击剑访谈</p>
                                </div>
                            </div>
                            <ul className="rightInner">
                                <Link to={"/video/"+this.state.videoHeroList[1]+'/2'}>
                                <li style={{backgroundImage:'url('+require('./../../pic/hero02.jpg')+')'}} title="广东击剑队队员邓小浩专访">
                                    <div className="play">
                                        <img src={playOS} alt=""></img>
                                        <span style={{color:(this.state.videoHeroIndex == 1 ? '#ff5d38' : '#fff')}}>广东击剑队队员邓小浩</span>
                                    </div>
                                </li>
                                </Link>
                                <Link to={"/video/"+this.state.videoHeroList[2]+'/1'}>
                                <li style={{backgroundImage:'url('+require('./../../pic/hero03.jpg')+')'}} title="击剑运动员 雷声 演讲">
                                    <div className="play">
                                        <img src={playOS} alt=""></img>
                                        <span style={{color:(this.state.videoHeroIndex == 2 ? '#ff5d38' : '#fff')}}>击剑运动员 雷声 演讲</span>
                                    </div>
                                </li>
                                </Link>
                                <Link to={"/video/"+this.state.videoHeroList[3]+'/1'}>
                                <li style={{backgroundImage:'url('+require('./../../pic/hero04.jpg')+')'}} title="击剑运动员孙伟 访谈">
                                    <div className="play">
                                        <img src={playOS} alt=""></img>
                                        <span style={{color:(this.state.videoHeroIndex == 3 ? '#ff5d38' : '#fff')}}>击剑运动员孙伟 访谈</span>
                                    </div>
                                </li> 
                                </Link>
                                <Link to={"/video/"+this.state.videoHeroList[4]+'/1'}>
                                <li style={{backgroundImage:'url('+require('./../../pic/hero05.jpg')+')'}} title="中国击剑访谈">
                                    <div className="play">
                                        <img src={playOS} alt=""></img>
                                        <span style={{color:(this.state.videoHeroIndex == 4 ? '#ff5d38' : '#fff')}}>中国击剑访谈</span>
                                    </div>
                                </li>
                                </Link>
                                <Link to={"/video/"+this.state.videoHeroList[5]+'/2'}>
                                <li style={{backgroundImage:'url('+require('./../../pic/hero06.jpg')+')'}} title="二青会击剑比赛 西安女子花剑勇夺团体冠军">
                                    <div className="play">
                                        <img src={playOS} alt=""></img>
                                        <span style={{color:(this.state.videoHeroIndex == 5 ? '#ff5d38' : '#fff')}}>二青会击剑比赛</span>
                                    </div>
                                </li>
                                </Link>
                            </ul>
                        </div>
                    }
                    </div>
                    <div className="display">
                        <Layout title="击剑培训">
                            
                            <div className="knowledge">
                                <div className="inner">
                                    <p>培训tips</p>
                                    <p><Link to="/train/2">孩子学击剑，家长从中扮演什么角色？</Link></p>
                                    <p><Link to="/train/1">几岁是练习击剑的最佳年龄？</Link></p>
                                    <p><Link to="/train/4">幼少儿的击剑体能训练</Link></p>
                                    <p><Link to="/train/3">击剑教育对女孩的好处多！</Link></p>
                                    <p><Link to="/train">查看更多</Link></p>
                                </div>
                            </div>
                            <div className="org_display">
                                <p>机构风采</p>
                                <ul>
                                    <li>
                                        <Link to="/train/7">
                                        <img src={require('./../../pic/display01.jpg')} alt="" title="江苏省体育局青少处及苏州体育局领导莅临佐罗击剑俱乐部视察工作"></img>
                                        <p>江苏省体育局青少处及苏州体育局领导莅临佐罗击剑俱乐部视察工作</p>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/train/8">
                                        <img src={require('./../../pic/display11.jpg')} alt="" title="祝贺许庭玮获得二青会男重甲组冠军!"></img>
                                        <p>祝贺许庭玮获得二青会男重甲组冠军！</p>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/train/9">
                                        <img src={require('./../../pic/display21.jpg')} alt="" title="佐罗击剑俱乐部应邀参加FM91.1苏州新闻广播直播栏目《听运动的声音》"></img>
                                        <p>佐罗击剑俱乐部应邀参加FM91.1苏州新闻广播直播栏目《听运动的声音》</p>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </Layout>
                    </div>
                    <div className="equipment">
                    <Layout title="击剑器材">
                        <div className="container">
                            <div className="leftInner">
                                {this.state.equipmentIndex === 0 &&
                                <div>
                                    <div className="pic">
                                        <Link to="/equipment/1">
                                        <img src={require('./../../pic/equipment01.jpg')} alt=""></img>
                                        <p>击剑面罩</p>
                                        </Link>
                                    </div>
                                    <div className="pic">
                                        <Link to="/equipment/2">
                                        <img src={require('./../../pic/equipment02.jpg')} alt=""></img>
                                        <p>剑</p>
                                        </Link>
                                    </div>
                                    <div className="pic">
                                        <Link to="/equipment/3">
                                        <img src={require('./../../pic/equipment03.jpg')} alt=""></img>
                                        <p>击剑服</p>
                                        </Link>
                                    </div>
                                </div>
                                }
                                {/* {this.state.equipmentIndex === 1 &&
                                <div>
                                    <div className="pic">
                                        <img src={bg2} alt=""></img>
                                        <p>击剑面罩1</p>
                                    </div>
                                    <div className="pic">
                                        <img src={bg2} alt=""></img>
                                        <p>击剑面罩1</p>
                                    </div>
                                </div>
                                }
                                {this.state.equipmentIndex === 2 &&
                                <div>
                                    <div className="pic">
                                        <img src={bg2} alt=""></img>
                                        <p>击剑面罩2</p>
                                    </div>
                                    <div className="pic">
                                        <img src={bg2} alt=""></img>
                                        <p>击剑面罩2</p>
                                    </div>
                                </div>
                                } */}
                                {/* <div className="spot">
                                    <span style={{background:this.state.equipmentIndex === 0 ? '#FF5D38' : '#DEDEDE'}}
                                    onMouseEnter={this.toggleEquipmentHover.bind(this,0)} 
                                    onMouseLeave={this.toggleEquipmentHover.bind(this,0)}></span>
                                    <span style={{background:this.state.equipmentIndex === 1 ? '#FF5D38' : '#DEDEDE'}}
                                    onMouseEnter={this.toggleEquipmentHover.bind(this,1)} 
                                    onMouseLeave={this.toggleEquipmentHover.bind(this,1)}></span>
                                    <span style={{background:this.state.equipmentIndex === 2 ? '#FF5D38' : '#DEDEDE'}}
                                    onMouseEnter={this.toggleEquipmentHover.bind(this,2)} 
                                    onMouseLeave={this.toggleEquipmentHover.bind(this,2)}></span>
                                </div> */}
                            </div>
                            <div className="rightInner">
                                <div>
                                    <p>器材知识</p>
                                    <p><Link to="/equipment/detail/2">怎样穿好击剑鞋？</Link></p>
                                    <p><Link to="/equipment/detail/3">剑戳在身上疼不疼？好的击剑服堪比防弹衣</Link></p>
                                    <p><Link to="/equipment/detail/4">“好剑在手，天下我有”</Link></p>
                                    <p><Link to="/equipment/detail/5">击剑手套臭了怎么办？</Link></p>
                                    <p><Link to="/equipment/detail/6">为什么击剑不用透明的面罩？</Link></p>
                                    <p><Link to="/equipment">查看更多</Link></p>
                                </div>
                                {/* <div>
                                    <p>器材测评</p>
                                    <p>击剑术语</p>
                                    <p>观赛礼仪</p>
                                    <p>击剑术语介绍-中英版</p>
                                    <p>击剑项目比赛规则</p>
                                    <p>击剑项目比赛规则</p>
                                    <p>击剑项目比赛规则</p>
                                    <p>击剑项目比赛规则</p>
                                    <p>查看更多</p>
                                </div> */}
                            </div>
                        </div>
                    </Layout>
                    </div>
                </section>
                ) : (
                    <section>
                        <Navigation tab="index"></Navigation>
                        <div className="banner_container1">
                            <div className="banner banner1">
                                {this.state.bannerClickIndex === 1 ? (  
                                    <div>
                                        <div className="arrow arrowr">
                                            <img src={arrowL} alt=""></img>
                                        </div>
                                        <div className="arrow arrowl" onClick={this.changeClickIndex.bind(this, 0)}>
                                            <img src={arrowBR} alt=""></img>
                                        </div>
                                    </div>
                                ):(  
                                    <div> 
                                        <div className="arrow arrowr" onClick={this.changeClickIndex.bind(this, 1)}>
                                            <img src={arrowBL} alt=""></img>
                                        </div>
                                        <div className="arrow arrowl">
                                            <img src={arrowR} alt=""></img>
                                        </div>
                                    </div>
                                )}
                                <div className="pic">
                                    {this.state.bannerBgList.map((bg,index) =>
                                    <Link to={"/video/"+this.state.bannerUrlList[index]+'/1'} key={index} >
                                        <div style={{transform: (this.state.bannerHoverIndex === index ? "scale(1.14)" : '')}} 
                                            onMouseEnter={this.toggleHover.bind(this,index)} 
                                            onMouseLeave={this.toggleHover.bind(this,index)}
                                            onClick={this.goVideo.bind(this,index)}>  
                                                <img src={bg} alt={index}></img>
                                                {this.state.bannerHoverIndex === index ? (
                                                    <div className="default hover">
                                                        <p>{this.state.bannerTitleList[index]}</p>
                                                        <div className="play">
                                                            <img src={playWS} alt=""></img>
                                                            <span>立即播放</span>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="default">
                                                        <p>{this.state.bannerTitleList[index]}</p>
                                                        <div className="play">
                                                            <img src={playOS} alt=""></img>
                                                            <span>播放量：{(index+1)*120+index*3+9+index}</span>
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                    </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                    
                    </section>
                )}
            </main>
        )
    }
};